import styled, { css } from 'styled-components';
import { FADE_TIME } from 'commons';

export const Wrapper = styled.div`
  width: 10px;
  position: relative;
`;

export const Button = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  top: -50%;
  right: 50%;
  transform: translate(50%, -50%);
  background-color: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.neutral_500};

  svg {
    transform: scaleY(-1);
  }
`;

export const PopUp = styled.div<{ $fade: boolean }>`
  position: absolute;
  bottom: 10px;
  right: 50%;
  transform: translate(50%, 0%);
  background-color: ${({ theme }) => theme.neutral_200};
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 300;
  color: ${({ theme }) => theme.neutral_500};

  ${({ $fade }) =>
    $fade &&
    css`
      transition: ${FADE_TIME}ms;
      opacity: 0;
    `}
`;
